let endPoint
let endPointV2
let host_name = window.location.host
host_name = host_name ? 'https://' + host_name + '/' : ''
switch (window.location.host) {
  case 'dev.v-comply.com':
    endPoint = 'https://devapi.v-comply.com'
    endPointV2 = 'api-uat1'
    break
  case 'app-migration-uat.v-comply.com':
    endPoint = 'https://tapi.v-comply.com'
    endPointV2 = 'api-uat1'
    break
  case 'app-uat-gcp.v-comply.com':
    endPoint = 'https://api-uat-gcp.v-comply.com'
    endPointV2 = 'apiv2-uat-gcp'
    break
  case 'beta.v-comply.com':
    endPoint = 'https://betaapi.v-comply.com'
    endPointV2 = 'api-staging'
    break
  case 'test.v-comply.com':
    endPoint = 'https://devapi.v-comply.com'
    endPointV2 = 'api-uat1'
    break
  case 'eu.v-comply.com':
    endPoint = 'https://euapi.v-comply.com'
    break
  case 'us.app.v-comply.com':
    endPoint = 'https://us.api.v-comply.com'
    break
  case 'app-migration-prod.v-comply.com':
    endPoint = 'https://apim.v-comply.com'
    endPointV2 = 'api-migration-prod'
    break
  default:
    if (window.location.host?.startsWith("app-uat-gcp")||window.location.host?.startsWith("rambo")||window.location.host?.startsWith("cosmo")) {
      endPoint = "https://api-uat-gcp.v-comply.com";
      endPointV2 = "apiv2-uat-gcp";
    } else if (window.location.host?.startsWith('dev-test') || window.location.host?.startsWith('app-uat')) {
      endPoint = 'https://devapi.v-comply.com'
      endPointV2 = 'api-uat1'
    } else if (host_name?.includes('app-migration-uat')) {
      endPoint = 'https://tapi.v-comply.com'
      endPointV2 = 'api-uat1'
    } else if (host_name?.includes('beta-test') || host_name?.includes('app-staging')) {
      endPoint = 'https://betaapi.v-comply.com'
      endPointV2 = 'api-staging'
    } else {
      endPoint = 'https://api-prod-gcp.v-comply.com'
      endPointV2 = 'apiv2-prod-gcp'
    }
    break
}

// export const environment = {
//   production: true,
//   appUrl: ((host_name === "") ? "https://dev.v-comply.com/" : host_name),
//   authEndpoint: `${endPoint}VcomplyAuth/`,
//   orgEndpoint_TL: `${endPoint}organization_pwt/?mode=`,
// };

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// let domainName  = "api-uat1";
export const environment = {
  production: true,
  appUrl: host_name,
  authEndpoint: endPoint + '/VcomplyAuth/',
  orgEndpoint_TL: endPoint + '/organization_pwt/?mode=',
  s3Url: '',
  s3BucketUrl: `${endPoint}/globals?mode=bucket`,
  s3Bucket: '',
  emailCheck: `https://${endPointV2}.v-comply.com/api/v1/`,
  vLoader: 'https://cdn.v-comply.com/logo/prod/v-icon-loader.svg?v=1.0',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
